import * as React from 'react'
import type { Currency, Language } from 'codegen/types'

import type { Key } from '../i18n'

export interface HeaderData {
  lang: Language
  currency: Currency
  i18n: (key: Key, values?: Record<string, string>) => string
  Image: React.ElementType
}
type ContextProps = React.PropsWithChildren<HeaderData>

const HeaderContext = React.createContext<HeaderData>(null!)

export function BannerContextProvider({ children, ...rest }: ContextProps) {
  return (
    <HeaderContext.Provider value={rest}>
      {React.useMemo(() => children, [children])}
    </HeaderContext.Provider>
  )
}

export function useHeaderContext() {
  return React.useContext(HeaderContext)
}

export function useLocale() {
  return useHeaderContext().lang
}

export function useCurrency() {
  return useHeaderContext().currency
}

export function useTranslations() {
  return useHeaderContext().i18n
}

export function useImage(): React.ElementType {
  return useHeaderContext().Image
}
